import React, { Dispatch, SetStateAction, useState } from "react";
import styled from "@emotion/styled";
import { Drawer } from "antd";

const DrawerContainer = styled(Drawer)<{ padding?: string }>(
  ({ theme, padding }) => ({
    borderRadius: "10px 10px 0 0",
    fontFamily: "Pretendard ,Sans-serif",
    maxWidth: "560px",

    ".ant-drawer-header": {
      display: "flex",
      borderBottom: "none",
    },

    ".ant-drawer-title": {
      display: "flex",
      justifyContent: "center",
    },

    ".ant-drawer-body": {
      display: "flex",
      flexDirection: "column",

      justifyContent: "space-between",
      padding: padding ? padding : "0 0 4.8rem",
      maxHeight: "70vh",
    },
  }),
);

const ContentWrapper = styled.div<{ wrapperPadding?: string }>(
  ({ theme, wrapperPadding }) => ({
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "space-between",
    gap: "1.6rem",
    color: theme.color.black,
    fontSize: "1.6rem",
    lineHeight: "2.4rem",
    padding: wrapperPadding ? wrapperPadding : "0 2rem",
  }),
);

const GrayBar = styled.div(({ theme }) => ({
  width: "9.3rem",
  height: "7px",
  backgroundColor: theme.color.border_gray,
  borderRadius: "10px",
}));

type Props = {
  children: React.ReactNode;
  open: boolean;
  setOpen: any;
  padding?: string;
  wrapperPadding?: string;
};
const BasicDrawer = ({
  children,
  open,
  setOpen,
  padding,
  wrapperPadding,
}: Props) => {
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <DrawerContainer
      title={<GrayBar />}
      closable={false}
      height="auto"
      placement="bottom"
      onClose={handleClose}
      open={open}
      padding={padding}>
      <ContentWrapper wrapperPadding={wrapperPadding}>
        {children}
      </ContentWrapper>
    </DrawerContainer>
  );
};

export default BasicDrawer;
